import React from "react";
import placeholderuser from '../../assets/images/userplaceholder.webp';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
const Newinstagrampost = () => {

    return (
        <div className="newuser-container">
            <p className="newuser-title fb-campaign-tittle">Add Instagram Post</p>
            <div className="newuser-form-box">


                <div className="newuser-form">
                  
                    <div className="newuser-field">
                        <label>Upload Image or Video</label>
                        <input type="file" name="media" accept="image/*,video/*" />

                    </div>
                    <div className="newuser-field">
                    <label>Media URL</label>
                    <input type="url"  placeholder="Media URL" />
                     </div>
                    <div className="newuser-field">
                    <label>Caption</label>
                    <textarea
                            name="message"
                            placeholder="Caption"
                            rows={5}
                        />
                    </div>
                    <div className="newuser-field">
                    <label>Hashtags </label>
                    <input
                      type="text"
                      placeholder="Hashtags (comma separated, e.g. travel,nature)"
                      className=""  />

                    </div>


                   

                </div>
                <div className="newuser-form">

                <div className="newuser-field">
                <label>Tag people</label>
                <input type="text"  placeholder="Tag people (comma separated usernames)" className="" />


                    </div>

                    <div className="newuser-field">
                    <label>Location</label>
                    <input  type="text" placeholder="Location" className=""  />

                    </div>
                    <div className="newuser-field">
                    <label>Add Music</label>
                    <input type="text" placeholder="Music Title / Artist (for reference)" className="" />



                    </div>
                    <div className="newuser-field">
                    <label>Audiance</label>
                    <select
        className=""   >
        <option value="everyone">Everyone</option>
        <option value="followers">Followers Only</option>
      </select>

                    </div>


                 

                   

                    <div className='mb-2'>
                        <button type="submit  " className="btn btn-primary newuser-btn"> Post to Instagram</button>

                    </div>
                </div>
            </div>
        </div>
    )
};
export default Newinstagrampost